import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { BaseEnvironmentConfig, ENV } from './base-environment-config';
import { BaseAppParameters } from './base-app-parameters';

@Injectable()
export abstract class AppParametersService<
  T extends BaseAppParameters,
  S extends BaseAppParameters = BaseAppParameters
> {
  protected parameterChangesSubject = new BehaviorSubject<T | null>(null);

  protected abstract parameters: T;

  get parameterChanges$(): Observable<T> {
    return this.parameterChangesSubject
      .asObservable()
      .pipe(filter((x) => x !== null)) as Observable<T>;
  }

  constructor(@Inject(ENV) protected environment: BaseEnvironmentConfig) {}

  getAppParametersFromDOM(elementId: string) {
    const parameterElement = document.querySelector<HTMLElement>(
      `#${elementId}`
    );
    if (parameterElement) {
      let inputConfig: S;
      try {
        inputConfig = JSON.parse(parameterElement.innerText);
      } catch (e) {
        throw new Error('App parameters JSON malformed.');
      }

      this.parameters.apiBaseUrl =
        inputConfig.apiBaseUrl || this.environment.apiBaseUrl;
      if (!this.parameters.apiBaseUrl)
        throw new Error('No API Base URL specified in app parameters.');
      this.parameters.apiBasicAuth =
        inputConfig.apiBasicAuth || this.environment.apiBasicAuth;
      if (!this.parameters.apiBasicAuth)
        throw new Error('No API Basic Auth specified in app parameters.');
      this.parameters.language =
        inputConfig.language || this.environment.language;
      if (!this.parameters.language)
        throw new Error('No Language specified in app parameters.');
      this.parameters.searchSubscriptionNewsletterSignupUrl =
        inputConfig.searchSubscriptionNewsletterSignupUrl;

      this.setAppParameters(inputConfig);

      this.parameterChangesSubject.next(this.parameters);
    } else {
      throw new Error(
        `No parameter script-element found for ID '${elementId}'.`
      );
    }
  }

  protected abstract setAppParameters(inputConfig: S): void;

  get(): T {
    return this.parameters;
  }
}
